<!--
 * @Description: 
-->
<template>
  <el-form class="serach-form" :inline="true" :model="filters" size="small">
    <!-- <el-form-item>
      <el-checkbox border v-model="filters.isPost" @change="checkChange"
        >只看班委</el-checkbox
      >
    </el-form-item> -->
    <el-form-item class="w-160">
      <el-input
        clearable
        placeholder="请选择工作单位"
        v-model="deptName"
        @focus="showDeptModal"
        @clear="clearDepts">
      </el-input>
    </el-form-item>
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.graduationStatus"
        placeholder="结业状态"
      >
        <el-option
          v-for="(item, i) in graduationStatusData"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="m-l-14">
      <el-input
        prefix-icon="el-icon-search"
        size="small"
        v-model.trim="filters.name"
        placeholder="姓名/手机号"
      ></el-input>
    </el-form-item>
    <el-form-item>
      <butn btntype="primary" title="查询" @click="initData"></butn>
      <butn title="重置" @click="resetData" class="czButn"></butn>
    </el-form-item>
    <SingleCheckTree ref="lazyTree" :classId="classId" :defaultCheckedKeys="defaultCheckedKeys" :showModal="deptDialog" @deptSelected="selectDept" showTooltip/>
  </el-form>
</template>

<script>
import butn from "@/components/button/index";
import { getDataMap } from "@/api/sysParam";
import SingleCheckTree from "@/views/offlineClass/students/singleCheckTree.vue";
export default {
  components: { butn, SingleCheckTree },
  data() {
    return {
      filters: {
        // isPost: false,
      },
      deptName: "",
      graduationStatusData: [],
      defaultCheckedKeys: [],
      deptDialog: {
        flag: false
      },
      classId: '',
    };
  },
  created() {
    this.classId = this.$route.query.id || '';
    getDataMap("CLASS_FINISH_STATUS").then((res) => {
      if (!res || res.code != 0) return;
      res.data.splice(0, 0, {
        paramKey: "",
        paramValue: "全部",
      });
      this.graduationStatusData = res.data;
    });
  },
  methods: {
    checkChange() {
      this.initData();
    },
    initData() {
      this.$emit("search", { ...this.filters, t: new Date().getTime() });
    },
    resetData() {
      this.deptName = '';
      this.filters = {};
      this.initData();
    },
    // 选择工作单位弹窗
    showDeptModal() {
      this.deptDialog.flag = true;
      this.$nextTick(()=> {
        this.$refs.lazyTree.$refs["deptTree"].setCheckedKeys(this.defaultCheckedKeys);
      })
    },
    clearDepts() {
      this.defaultCheckedKeys = [];
      this.filters.deptLevelCodeQuery = "";
      this.$nextTick(()=> {
        this.$refs.lazyTree.$refs["deptTree"].setCheckedKeys(this.defaultCheckedKeys);
      })
    },
    // 工作单位选择确定
    selectDept(dept) {
      this.deptName = dept.deptName;
      this.filters.deptLevelCodeQuery = dept.deptLevelCode;
      this.defaultCheckedKeys = [dept.uuid];
      this.deptDialog.flag = false;
    }
  },
};
</script>

<style lang="scss" scoped>
.serach-form {
  // text-align: right;
  .w-160 {
    width: 160px;
  }
}
</style>
